module.exports = __webpack_public_path__ + "static/media/sounak.bd35165c.jpeg";